<div class="grid text-center pt-3 w-full">
  <div class="col-12 pb-0">© Voxel - All rights reserved |
    <a href="https://www.voxelgroup.net/legal-notice">Legal Notice</a> |
    <a href="https://www.voxelgroup.net/privacy-policy">Privacy</a> |
    <a href="https://www.voxelgroup.net/cookies-policy">Cookies</a>
  </div>
  @if (info | async; as info) {
    <div class="col-12 pt-0">{{info.apiVersion}}</div>
  }
</div>
